var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page',{attrs:{"name":"Article","use":"_id","display":_vm.display,"display-html":"","page-prefix":"/blade/articles","fetch":_vm.getArticles,"remove":_vm.deleteArticle,"sort-options":_vm.sortOptions,"sort-functions":_vm.sortFunctions,"default-sort":_vm.defaultSort}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4757f6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/ArticlesList.vue
// module id = null
// module chunks = 